
import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const UsageTips = () => {
  const { t } = useTranslation('common');
  
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">{t('help.usageTips.title')}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
        <div className="bg-green-50 p-3 rounded-md">
          <p className="text-green-800">
            <strong>Régularité :</strong> {t('help.usageTips.regularity')}
          </p>
        </div>
        <div className="bg-blue-50 p-3 rounded-md">
          <p className="text-blue-800">
            <strong>Progression :</strong> {t('help.usageTips.progression')}
          </p>
        </div>
        <div className="bg-orange-50 p-3 rounded-md">
          <p className="text-orange-800">
            <strong>Patience :</strong> {t('help.usageTips.patience')}
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default UsageTips;
